export const Spinner = 'atlantis-spinner';
export const InlineLoader = 'atlantis-inline-loader';